import React from 'react';
import ModalWrapper from './ModalWrapper';

interface Props {
  show: boolean;
  title: string;
  message: React.ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
  confirmButtonClass?: string;
  iconClass?: string;
}

export default function ConfirmationModal({
  show,
  title,
  message,
  onConfirm,
  onCancel,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmButtonClass = 'btn-primary',
  iconClass = 'fe fe-help-circle text-primary',
}: Props) {
  if (!show) return null;

  return (
    <ModalWrapper show={show} title={title} onClose={onCancel}>
      <div className="modal-body">
        <div className="d-flex">
          <div className="me-3">
            <i className={`${iconClass} fs-1`}></i>
          </div>
          <div className="flex-grow-1 d-flex align-items-center">
            {typeof message === 'string' ? <p className="mb-0">{message}</p> : message}
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <button className="btn btn-light" onClick={onCancel}>
          {cancelText}
        </button>
        <button className={`btn ${confirmButtonClass}`} onClick={onConfirm}>
          {confirmText}
        </button>
      </div>
    </ModalWrapper>
  );
}
